import React, { useState } from "react";
import { MagneticBar } from "./MagneticBar";
import { ScrambleTextControlled } from "./ScrambleText";

const Arrow = () => (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
        <path d="M1 0V6C0.999976 7 1.1 8.5 3.5 8.5C5.9 8.5 10.5 8.5 11.5 8.5" stroke="currentColor" />
        <path d="M8 4L12.5 8.5L8 13" stroke="currentColor" />
    </svg>
);

/**
 * Premium action button used everywhere "LEARN MORE"-style links appear.
 * - Cursor-tracking compass equalizer line beneath the text
 * - Letter scramble effect on hover
 * - Optional arrow icon (left/right/none)
 */
export const ActionButton = ({
    children,
    href = "#",
    arrow = "left",          // "left" | "right" | "none"
    color = "currentColor",
    onClick,
    className = "",
    style = {},
    testId,
    barCount = 60,
    peakHeight = 16,
}) => {
    const [hover, setHover] = useState(false);
    const label = typeof children === "string" ? children : "";

    const Content = (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 14,
                position: "relative",
                color,
                fontFamily: "Manrope, sans-serif",
                fontSize: 14,
                letterSpacing: "0.22em",
                textTransform: "uppercase",
                fontWeight: 500,
                lineHeight: 1,
            }}
        >
            {arrow === "left" && <Arrow />}
            <ScrambleTextControlled text={label} active={hover} duration={420} stagger={22} />
            {arrow === "right" && <Arrow />}
        </span>
    );

    return (
        <a
            href={href}
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className={`yk-action-btn ${className}`}
            style={{
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "stretch",
                gap: 10,
                padding: "10px 0 6px",
                minWidth: 220,
                textDecoration: "none",
                cursor: "pointer",
                ...style,
            }}
            data-testid={testId}
        >
            {Content}
            <MagneticBar
                barCount={barCount}
                peakHeight={peakHeight}
                baseHeight={3}
                falloff={0.075}
                color={color}
                active={hover}
            />
        </a>
    );
};

export default ActionButton;
